// core version + navigation, pagination modules:
// import Swiper, {Pagination, EffectFade, Autoplay, A11y} from 'swiper';

export default {
  finalize() {
    /* global flatpickr, locale */
    // const isMobile = window.matchMedia('(max-width: 1024px)').matches;

    const datePicker = flatpickr('#checkin', {
        mode: 'range',
        minDate: 'today',
        showMonths: 1,
        locale: locale.current,
        allowInput: false,
        dateFormat: 'Y-m-d',
        onChange: function(selectedDates) {
          const label = document.getElementById('durationLabel');

          if (selectedDates.length === 0) {
            label.textContent = '{!! __("Durata soggiorno", "mktg") !!}';
            return;
          }

          const checkinDate = selectedDates[0];
          const checkoutDate = selectedDates[1];

          document.getElementById('checkin').value = checkinDate.toISOString().split('T')[0];
          if (checkoutDate) {
            document.getElementById('checkout').value = checkoutDate.toISOString().split('T')[0];
          }

          if (checkoutDate) {
            label.textContent =
              checkinDate.toLocaleDateString(locale.current, { day: 'numeric', month: 'short' }) +
              ' , ' +
              checkoutDate.toLocaleDateString(locale.current, { day: 'numeric', month: 'short' });
          } else {
            label.textContent = checkinDate.toLocaleDateString(locale.current, { day: 'numeric', month: 'short' });
          }
        },
      });

      document.getElementById('durationText').addEventListener('click', function() {
        datePicker.open();
      });

    window.booking = window.booking || {};
    window.booking.submit = function () {
      const hotelCode = parseInt(document.getElementById('hotel_code').value);
      const checkin = datePicker.selectedDates[0].yyyymmdd();
      const checkout = datePicker.selectedDates[1].yyyymmdd();
      const adults = parseInt(document.querySelector('input[name="adults"]').value);
      const children = parseInt(document.querySelector('input[name="children"]').value);
      const childrenage = document.getElementsByName('childrenage[]');
      let ages = '';
      if (childrenage.length > 0) {
        ages = '&ages=';
        for (let i = 0; i < childrenage.length; i++) {
          ages += childrenage[i].value + ',';
        }
        ages = ages.slice(0, -1);
      }

      const base_ermes_url = hotelCode > 0 ? locale.ermes_base_url.replace('/#', '/#/hotel/' + hotelCode).replace('/?', '/rooms/?') : locale.ermes_base_url;

      window.open(base_ermes_url + 'arrival=' + checkin + '&departure=' + checkout + '&adults=' + adults + '&childs=' + children + ages, '_blank');
    }
  },
};

